"use client";

import { useTranslation } from "react-i18next";
import { MobileMenu } from "@/data/types";
import Image from "next/image";
import giftCardIcon from "@/images/icons/gift-card.svg";
import paymentMethodIcon from "@/images/icons/paymentMethod.svg";

export const useGiftMenu = (): MobileMenu[] => {
  const { t } = useTranslation("guydeez");

  return [
    {
      href: "/gift-cards",
      name: t("menu_gift_cards"),
      description: t("menu_gift_cards_description"),
      icon: () => (
        <Image
          src={giftCardIcon}
          alt={t("menu_gift_cards")}
          width={24}
          height={24}
        />
      ),
    },
    {
      href: "/redeem",
      name: t("menu_redeem"),
      description: t("menu_redeem_description"),
      icon: () => (
        <Image
          src={paymentMethodIcon}
          alt={t("menu_redeem")}
          width={24}
          height={24}
        />
      ),
    },
  ];
};

export default useGiftMenu;
